import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { API_URL } from "../../../Services/ApiService";
import { showSuccessAlert, toastEmmit } from "../../../Helper/Toastr";
import {  useNavigate } from "react-router-dom";

export default function EmailVerify(Email) {
  const navigate = useNavigate()
  const [email, setemail] = useState("");
 
  const [loader, setLoader] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [Error, setError] = useState("");
  const inputRefs = useRef(Array(6).fill(null));

  useEffect(() => {
    // console.log(Email);
    ClearValue() 
    setTimeout(() => { 
      inputRefs.current[0]?.focus()
  }, 500) 
    setemail(Email?.Email);
    setsubmit(false)
    setError("")
  }, [Email]);

  const handleChange = (e, index) => {
    const value = e.target.value; 
    const value1 = value.replace(/\D/, '');
    // Update the input value
    e.target.value = value1;
 
    if (value.length === 1 && !isNaN(value) && index < 5) {
      inputRefs.current[index + 1].focus();
    }
    // if (value.length === 0 && index > 0) {
    //   inputRefs.current[index - 1].focus();
    // }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !inputRefs.current[index].value) {
      inputRefs.current[index-1].focus();
    }
  };

  const verifyOTP = () => { 
    const otp = inputRefs.current.map((input) => input.value).join("");

    const isEmpty = inputRefs.current.some((input) => input.value === "");

    if (isEmpty) {
      setsubmit(true);
      setError("Please fill all the OTP digits.");
      return;  
    }else{
      setsubmit(false)
      setError("")
    }

    console.log(email, otp);
    setLoader(true);
    axios
      .post(API_URL.VERIFY_OTP, { email: email, otp: Number(otp) })
      .then((res) => {
        console.log("OTP verified & login successfully:", res.data);
        localStorage.clear()
        localStorage.setItem("token", res?.data?.data?.accessToken);
        localStorage.setItem("count", res?.data?.data?.cartCount);
        localStorage.setItem("user", res?.data?.data?.fullName);
        const path = window.location.href;
            const newwe = path.split("#");
            navigate(newwe[1]);
        // updateCart(res?.data?.data?.cartCount);
        setLoader(false);
        document.getElementById("closeModal").click();
        toastEmmit("success", "OTP verified & login successfully");
      })
      .catch((error) => {
        console.error("Error verifying OTP:", error);
        toastEmmit("error", error?.response?.data?.message);
        setLoader(false);
      });
  };

  const ClearValue = () => { 
    inputRefs.current.forEach((input) => {
      input.value = "";  
    });
  };  

  return (
    <div
      className="modal fade index"
      id="emailverify"
      tabIndex={-1}
      aria-labelledby="exampleModalLabelone"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false" 
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeModal"
            />
          </div>
          <div className="modal-body popup border-0 pb-50">
            <h4>Email Verification</h4>
            <p>
              Please enter the 6-digit verification code sent to <span className="fw-bold">{email}</span>
            </p>
            <form className="pt-10">
              <div className="row justify-content-center">
                <div className="col-11 d-flex ">
                  {[...Array(6)].map((_, index) => (
                    <div
                      key={index}
                      className="col-xl-2 col-lg-2 col-md-2 tp-register__input-box px-1"
                    >
                      <input
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="text"
                        maxLength={1}
                        className="form-control text-center pe-3"
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        required 
                      />
                    </div>
                  ))}
                </div>
                  {(submit && Error !=="") && <span className="mb-0 mt-3 error text-center">{Error}</span>}
                <div className="col-xl-11 col-lg-11 col-md-12 col-sm-12 mt-40">
                  <button
                    className={`tp-btn-lg large head tp-contact-4__btn tp-btn-square w-100 popup ${
                      loader ? "disabled" : ""
                    }`}
                    type="button"
                    onClick={verifyOTP}
                  >
                    {loader ? (
                      <span>
                        <i className="fa fa-spinner fa-spin fa-fw"></i>
                      </span>
                    ) : (
                      "Verify"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
